import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import prismic from '../prismic';
import PageTitle from 'components/PageTitle';
import Markup from 'components/Markup';
import Layout from 'components/Layout';
import CategoriesList from 'components/Categories';
import PageContainer, { Wrap } from 'components/PageContainer';
import { fetchCategories } from 'actions/categories';

class Categories extends Component {
  static async getInitialProps({ store, req, lang, prismicRef }) {
    return store.dispatch(fetchCategories({ lang, prismicRef }));
  }

  render() {
    const { categories, categories_page, ...rest } = this.props;
    const { meta, body } = prismic.categories(categories_page);
    return (
      <Layout {...rest} dept="product-checker" meta={meta}>
        <PageContainer>
          <PageTitle center>{meta.title}</PageTitle>
          <div className="text-center">
            <Markup>{body}</Markup>
          </div>
          <Wrap>
            <CategoriesList.Browse items={categories.items} />
          </Wrap>
        </PageContainer>
      </Layout>
    );
  }
}

Categories.propTypes = {
  categories: PropTypes.object,
  categories_page: PropTypes.object
};

export default connect(({ categories, prismic }) => ({
  categories,
  categories_page: prismic.categories
}))(Categories);
